"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserSettingsPaymentsQueryRenderer = exports.UserSettingsPaymentsFragmentContainer = exports.UserSettingsPayments = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.array.map");

var _palette = require("@artsy/palette");

var _Artsy = require("../../Artsy");

var _get = require("../../Utils/get");

var _renderWithLoadProgress = require("../../Artsy/Relay/renderWithLoadProgress");

var _react = _interopRequireWildcard(require("react"));

var _reactRelay = require("react-relay");

var _PaymentFormWrapper = require("./PaymentFormWrapper");

var _SavedCreditCards = require("./SavedCreditCards");

var _graphql;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var UserSettingsPayments =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UserSettingsPayments, _React$Component);

  function UserSettingsPayments() {
    _classCallCheck(this, UserSettingsPayments);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserSettingsPayments).apply(this, arguments));
  }

  _createClass(UserSettingsPayments, [{
    key: "render",
    value: function render() {
      var creditCardEdges = (0, _get.get)(this.props, function (props) {
        return props.me.creditCards.edges;
      });
      var creditCards = creditCardEdges.map(function (_ref) {
        var creditCard = _ref.node;
        return creditCard;
      });
      return _react.default.createElement(_palette.Theme, null, _react.default.createElement(_react.default.Fragment, null, creditCards && creditCards.length ? _react.default.createElement(_palette.Box, {
        maxWidth: 542
      }, _react.default.createElement(_SavedCreditCards.SavedCreditCards, {
        creditCards: creditCards,
        relay: this.props.relay,
        me: this.props.me
      }), _react.default.createElement(_palette.Serif, {
        size: "6",
        pb: 3,
        pt: 2
      }, "Add new card")) : null, _react.default.createElement(_PaymentFormWrapper.PaymentFormWrapper, {
        relay: this.props.relay,
        me: this.props.me
      })));
    }
  }]);

  return UserSettingsPayments;
}(_react.default.Component);

exports.UserSettingsPayments = UserSettingsPayments;
({
  data: function data() {
    var node = require("../../__generated__/UserSettingsPaymentsCreditCard.graphql");

    if (node.hash && node.hash !== "1863425d7a32a3efc69f0f7df7032585") {
      console.error("The definition of 'UserSettingsPaymentsCreditCard' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data.");
    }

    return require("../../__generated__/UserSettingsPaymentsCreditCard.graphql");
  }
});
var UserSettingsPaymentsFragmentContainer = (0, _reactRelay.createFragmentContainer)(UserSettingsPayments, {
  me: function me() {
    var node = require("../../__generated__/UserSettingsPayments_me.graphql");

    if (node.hash && node.hash !== "7f6b3cc640e79e84d066e0424e95aa7e") {
      console.error("The definition of 'UserSettingsPayments_me' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data.");
    }

    return require("../../__generated__/UserSettingsPayments_me.graphql");
  }
});
exports.UserSettingsPaymentsFragmentContainer = UserSettingsPaymentsFragmentContainer;

var UserSettingsPaymentsQueryRenderer = function UserSettingsPaymentsQueryRenderer() {
  var _useContext = (0, _react.useContext)(_Artsy.SystemContext),
      user = _useContext.user,
      relayEnvironment = _useContext.relayEnvironment;

  if (!user) {
    return null;
  }

  return _react.default.createElement(_reactRelay.QueryRenderer, {
    environment: relayEnvironment,
    variables: {},
    query: _graphql || (_graphql = function _graphql() {
      var node = require("../../__generated__/UserSettingsPaymentsQuery.graphql");

      if (node.hash && node.hash !== "979a38cba2d2f95be025a730d894ca44") {
        console.error("The definition of 'UserSettingsPaymentsQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data.");
      }

      return require("../../__generated__/UserSettingsPaymentsQuery.graphql");
    }),
    render: (0, _renderWithLoadProgress.renderWithLoadProgress)(UserSettingsPaymentsFragmentContainer)
  });
};

exports.UserSettingsPaymentsQueryRenderer = UserSettingsPaymentsQueryRenderer;
//# sourceMappingURL=UserSettingsPayments.js.map